import React, { createContext, useContext } from "react";
import useOciUrlHook from "../../../hooks/Dashboard/oci/useUrl";

export const OciUrlContext = createContext();

export const OciUrlProvider = ({ children }) => {
  const data = useOciUrlHook();
  return <OciUrlContext.Provider value={data}>{children}</OciUrlContext.Provider>;
};

export const useOciUrl = () => useContext(OciUrlContext);
